var React = require('react');

function FooterFbLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M86.9216 1.04066e-07H5.07393C2.27136 0.00168468 -0.000561419 2.27473 1.04066e-07 5.07842V86.9261C0.00168468 89.7286 2.27473 92.0006 5.07842 92H49.1445V56.4219H37.1953V42.4961H49.1445V32.2477C49.1445 20.3631 56.4 13.8943 67.0015 13.8943C72.0794 13.8943 76.443 14.2728 77.7148 14.4418V26.8633H70.4044C64.6364 26.8633 63.5195 29.6041 63.5195 33.6268V42.4961H77.3105L75.5137 56.4219H63.5195V92H86.9216C89.7258 92.0006 91.9994 89.7281 92 86.9238C92 86.9233 92 86.9227 92 86.9216V5.07393C91.9989 2.27136 89.7253 -0.000561419 86.9216 1.04066e-07Z","fill":"#14223C"}));
}

FooterFbLogo.defaultProps = {"width":"92","height":"92","viewBox":"0 0 92 92","fill":"none"};

module.exports = FooterFbLogo;

FooterFbLogo.default = FooterFbLogo;
